export default __webpack_public_path__ + "00537880d20ef7301e84a4a6cc78aab2.png";